import { useState } from 'react';
import { RegistrationApiService } from '@/features/b2b/register/services/registrationService';

export const useRegistrationSubmission = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const submitRegistrationNotificationAbandoned = async (requestData) => {
    try {
      const response = await RegistrationApiService.sendAbandonedNotification(requestData);
      return response.success;
    } catch (error) {
      console.error('Error in notification process:', error);
      return false;
    }
  };

  const submitRegistration = async (requestData) => {
    setIsSubmitting(true);

    if (!isCaptchaValid) {
      setIsSubmitting(false);
      return false;
    }

    try {
      // The server runs the CPD21 lookup, SugarCRM submission, emails and notification
      await RegistrationApiService.submitRegistration(requestData, turnstileToken);
      setIsSuccessful(true);
      return true;
    } catch (error) {
      console.error('Error in submission process:', error);
      setErrorMessage('Registration failed. Please try again or contact support.');
      setIsSuccessful(false);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    isSuccessful,
    isCaptchaValid,
    errorMessage,
    setIsCaptchaValid,
    setTurnstileToken,
    setErrorMessage,
    submitRegistrationNotificationAbandoned,
    submitRegistration,
  };
};
